import React from 'react';
import { LoadingGrid, formatPrice } from '../../../../../rbts/helpers';
import { useGetAllSalesSupplier } from '../hooks/SalesSupplierHook';

type Props = {
  filter: any;
};

const headerStyle: React.CSSProperties = { backgroundColor: '#8e949f' };
const totalStyle: React.CSSProperties = { backgroundColor: '#f0f1f5' };

const SalesSupplierGrid: React.FC<Props> = ({ filter }) => {
  const { data, loadingRequest } = useGetAllSalesSupplier(filter);

  if (!filter?.id_dia) {
    return (
      <div className="text-center text-muted py-8 fs-6">
        Seleccione un día administrativo para ver las ventas.
      </div>
    );
  }

  if (loadingRequest) return <LoadingGrid text="Cargando..." />;

  if (!data || data.length === 0) {
    return (
      <div className="text-center text-muted py-8 fs-6">
        No se encontraron ventas registradas.
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-rounded border gs-5">
        <thead>
          <tr className="fw-bolder fs-7 text-gray-800 border-bottom border-gray-200">
            <th>Producto</th>
            <th className="text-center">Cantidad</th>
            <th className="text-end">Precio Unit.</th>
            <th className="text-end">Subtotal</th>
          </tr>
        </thead>
        {data.map((venta: any) => {
          const fecha = venta.created_at
            ? new Date(venta.created_at).toLocaleString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
            : venta.dia?.fecha
            ? new Date(venta.dia.fecha).toLocaleDateString('es-MX')
            : '—';

          return (
            <tbody
              key={venta.id}
              style={{ outline: '2px solid #c2c6d0', outlineOffset: '-1px' }}
            >
              {/* Encabezado de venta */}
              <tr style={headerStyle}>
                <td
                  colSpan={4}
                  className="fw-bolder fs-7 ps-3 py-2"
                  style={{ color: '#1e3a5f' }}
                >
                  {fecha}
                  <span className="fw-normal ms-3" style={{ color: '#3a5080' }}>
                    — {venta.punto_venta_comprador?.nombre ?? '—'}
                  </span>
                </td>
              </tr>

              {/* Filas de detalle */}
              {venta.detalle && venta.detalle.length > 0 ? (
                venta.detalle.map((item: any, idx: number) => (
                  <tr key={idx} className="align-middle">
                    <td className="fs-7">{item.producto?.nombre ?? '—'}</td>
                    <td className="text-center fs-7">{item.cantidad}</td>
                    <td className="text-end fs-7">
                      {formatPrice(item.precio_unitario ?? 0, 'es-MX', 'MXN', 2, 2)}
                    </td>
                    <td className="text-end fs-7 fw-semibold">
                      {formatPrice(item.precio_total ?? 0, 'es-MX', 'MXN', 2, 2)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={4}
                    className="text-center text-muted fst-italic fs-7 py-2"
                  >
                    Sin productos registrados
                  </td>
                </tr>
              )}

              {/* Fila de total */}
              <tr style={totalStyle}>
                <td
                  colSpan={3}
                  className="text-end fs-7 fw-bolder"
                  style={{ color: '#1e3a5f' }}
                >
                  Total:
                </td>
                <td className="text-end fs-7 fw-bolder" style={{ color: '#1a7a4a' }}>
                  {formatPrice(venta.monto_total ?? 0, 'es-MX', 'MXN', 2, 2)}
                </td>
              </tr>

              {/* Separador */}
              <tr>
                <td colSpan={4} style={{ height: '10px', padding: 0 }} />
              </tr>
            </tbody>
          );
        })}
      </table>
    </div>
  );
};

export { SalesSupplierGrid };
